import contact from './contact';

export default `

    <div class="container">
        <div class="row align-items-center mt-2 mt-lg-5">
            <div class="col-lg-6">
                <div class="banner-content">
                    <h1>Wrinkle-free clothes can be,</h1>
                    <h2>hassle-free from now on.</h2>
                    <p>Premium ironing starts at Rs.10/Cloth</p>
                    ${contact}
                </div>
            </div>
            <div class="col-lg-6">
                <div class="banner-image">
                    <img alt="ironed-Cloth" src="./assets/img/cloth.png" />
                </div>
            </div>
        </div>
    <div>
`